


































import Vue from 'vue'
import VideoPlayer from '@/components/VideoPlayer'
import VuMeter from '@/components/VuMeter'
import fb from '../../firebase'
import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'
import './FinalOutputPlayer.scss'
import { StreamDoc, Stream } from '@/types/streams'

type UnsubscribeFunction = () => void

export default Vue.extend({
  name: 'FinalOutputPlayer',
  props: {
    mute: {
      type: Boolean,
      default: true
    },
    showMaximize: {
      type: Boolean,
      default: true
    },
    castId: {
      type: String
    },
    videoToLoad: {
      type: String
    },
    streamsManager: {
      type: Object
    },
    audioActivated: {
      type: Boolean
    }
  },
  data: () => ({
    streamDoc: {} as StreamDoc,
    variantToLoad: '',
    refId: null,
    subscribeFunction: null as null|UnsubscribeFunction
  }),
  created () {
    this.loadStreamDoc()
  },
  destroyed () {
    this.unloadStreamDoc()
  },
  computed: {
    previewUrl (): string {
      const route = this.$router.resolve({ name: 'preview', params: { id: this.castId } })
      return route.href
    },
    videoReady (): boolean {
      let status = false
      if (this.videoSource !== null) {
        if (this.videoSource.hasOwnProperty('srcObject')) {
          status = true
        }
      }
      return status
    },
    videoSource (): Stream|null {
      let source = null
      if (this.streamsManager.hasOwnProperty(this.videoToLoad)) {
        source = this.streamsManager[this.videoToLoad]
      }
      return source
    }
  },
  watch: {
    videoToLoad () {
      this.loadStreamDoc()
    }
  },
  methods: {
    unloadStreamDoc () {
      if (this.subscribeFunction !== null) {
        this.subscribeFunction()
        this.subscribeFunction = null
      }
    },
    loadStreamDoc () {
      this.unloadStreamDoc()
      if (this.videoToLoad !== '') {
        this.subscribeFunction = fb.db.collection('streams').doc(this.videoToLoad).onSnapshot(snap => {
          if (snap.exists === true) {
            this.streamDoc = snap.data() as StreamDoc
            if (this.streamDoc.hasOwnProperty('variants')) {
              if (this.streamDoc.variants.hasOwnProperty('original')) {
                this.$emit('addOutputVideo', { video: this.videoToLoad, variant: this.streamDoc.variants.original })
              }
            }
          } else {
            console.log('no stream doc found for ', this.videoToLoad)
          }
        }, error => {
          console.error('error loadStreamDoc ' + this.videoToLoad + ' ' + error)
        })
      }
    },
    toggleMute () {
      this.$emit('toggleMute')
    },
    videoClicked () {
      this.$emit('videoClicked')
    }
  },
  components: {
    VideoPlayer,
    VuMeter,
    'clip-loader': ClipLoader
  }
})
